// Lightweight client-side event tracker. Fire-and-forget - analytics
// must never break a user flow, so every call is wrapped and swallowed.
//
// Server accepts a small, whitelisted set of canonical event names
// (see /app/backend/routes_admin_analytics.py _CANONICAL_TO_LEGACY).
import api from "@/lib/api";

export const AnalyticsEvent = Object.freeze({
  SIGNUP_COMPLETED: "signup_completed",
  RESUME_UPLOADED: "resume_uploaded",
  JOB_DESCRIPTION_ADDED: "job_description_added",
  PREDICTED_QUESTIONS_VIEWED: "predicted_questions_viewed",
  MOCK_INTERVIEW_STARTED: "mock_interview_started",
  MOCK_INTERVIEW_COMPLETED: "mock_interview_completed",
  INTERVIEW_FEEDBACK_VIEWED: "interview_feedback_viewed",
  REPLAY_OPENED: "replay_opened",
  UPGRADE_VIEWED: "upgrade_viewed",
  CHECKOUT_STARTED: "checkout_started",
  PURCHASE_COMPLETED: "purchase_completed",
  SUBSCRIPTION_STARTED: "subscription_started",
  SUBSCRIPTION_CANCELLED: "subscription_cancelled",
});

// Anonymous events (guest funnel) - no auth required, server-whitelisted.
export function publicTrack(event, meta) {
  if (!event) return;
  api.post("/public/track", { event, properties: meta || {} })
    .catch(() => { /* swallow, analytics is best-effort */ });
}

export function track(event, meta) {
  if (!event) return;
  // Fire-and-forget. We never await; we never surface errors.
  // NOTE: the server model reads `properties` - send meta under that key
  // (it was previously sent as `meta` and silently dropped).
  api.post("/analytics/track", { event, properties: meta || {} })
    .catch((e) => { /* swallow, analytics is best-effort */
      if (typeof console !== "undefined") console.debug("[analytics] track failed", event, e?.message);
    });
}
